var _path, _path2, _path3;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function Svg24Support(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 36,
    height: 36,
    viewBox: "0 0 36 36",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M27 28.2896H25.86C24.66 28.2896 23.52 28.7546 22.68 29.5946L20.115 32.1297C18.945 33.2847 17.04 33.2847 15.87 32.1297L13.305 29.5946C12.465 28.7546 11.31 28.2896 10.125 28.2896H9C6.51 28.2896 4.5 26.2947 4.5 23.8347V7.4696C4.5 5.0096 6.51 3.01465 9 3.01465H27C29.49 3.01465 31.5 5.0096 31.5 7.4696V23.8347C31.5 26.2797 29.49 28.2896 27 28.2896Z",
    stroke: "#00A6A6",
    strokeWidth: 2,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M10.5 13.7402C10.5 12.3452 11.64 11.2051 13.035 11.2051C14.43 11.2051 15.57 12.3452 15.57 13.7402C15.57 16.5602 11.565 16.8602 10.68 19.5452C10.5 20.1002 10.965 20.6552 11.55 20.6552H15.57",
    stroke: "#00A6A6",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M24.06 20.6403V12.0753C24.06 11.6853 23.805 11.3403 23.43 11.2353C23.055 11.1303 22.65 11.2803 22.44 11.6103C21.36 13.3503 20.19 15.3303 19.17 17.0703C19.005 17.3553 19.005 17.7303 19.17 18.0153C19.335 18.3003 19.65 18.4802 19.995 18.4802H25.5",
    stroke: "#00A6A6",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(Svg24Support);
export default __webpack_public_path__ + "static/media/24-support.d7bd06795bd5ac517fd8d7996bf30ef1.svg";
export { ForwardRef as ReactComponent };